import styles from "./styles.module.scss";
import { Users } from "lucide-react";
import { _ } from "i18n";

interface CoachReviewsDisabledTeamProps {
	teamName: string;
}

export const CoachReviewsDisabledTeam = ({ teamName }: CoachReviewsDisabledTeamProps) => {
	return (
		<div className={styles["disabled-team"]}>
			<Users size={20} />
			<p>{_("game.coachReviews.team.title", { teamName: teamName })}</p>
		</div>
	);
};
